import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../env";
import { LoadingSpinner } from "../components/loading";
import { MarkdownFromUrl } from "../components/Markdown";

const ResourceType = {
    VIDEO: 0,
    AUDIO: 1,
    IMAGE: 2,
    TEXT: 3,
    OTHER: 4
}

function getResourceType(type) {
    if(!type) return ResourceType.OTHER
    if(type.includes("video")) return ResourceType.VIDEO
    if(type.includes("image")) return ResourceType.IMAGE
    if(type.includes("audio")) return ResourceType.AUDIO
    if(type.includes("text") || type.includes("markdown")) return ResourceType.TEXT
    return ResourceType.OTHER
}

export default function ExploreSpark() {

    const navigate = useNavigate()

    const { id } = useParams()
    const [spark, setSpark] = useState(undefined)

    useEffect(() => {
        api.get(`sparks/${id}`)
            .then(res => setSpark(res.data))
            .catch(_ => navigate('../'))
    }, [id])

    const handleBack = () => navigate('../')

    return(<div className="standard-padding flex mh-100 columns center justify-center relative">
        <p className="section-title v-spacer-xxs text-center upper-layer">{spark?.displayName}</p>
        <p className="card-body v-spacer-l text-center upper-layer">{spark?.description}</p>
        {spark && <DisplayResrouce url={spark.content.url} mime={spark.content.type}/>}
        {!spark && <LoadingSpinner className={'dashed-card standard-padding flex columns center gap-xs'} style={{width: 'clamp(100px, 85%, 500px)'}} label={'Loading your Spark...'}/>}
        <button className="solid with-icon leading vi-spacer-l upper-layer" onClick={handleBack}><span className="material-symbols-outlined scale-xxs">undo</span>Back</button>
        <div className="es-dot-1"></div>
        <div className="es-dot-2"></div>
    </div>)
}

export function DisplayResrouce({url, mime}) {

    const [type, setType] = useState(ResourceType.AUDIO)
    useEffect(() => {
        setType(getResourceType(mime))
    }, [mime])

    return(<>
        <div className="flex justify-center upper-layer" style={{ width: "clamp(150px, 85%, 750px)" }}>
            {type == ResourceType.VIDEO && <video controls width={"100%"} className="shadow radius">
                <source src={url} type={mime} />
                Your browser does not support the video tag.
            </video>}
            {type == ResourceType.AUDIO && <audio controls className="shadow-elevated" style={{borderRadius: "100px"}}>
                <source src={url} type={mime} />
                Your browser does not support the audio element.
            </audio>}
            {type == ResourceType.IMAGE && <img src={url} alt="Media" className="w-100 shadow radius" style={{backgroundColor: "rgb(var(--surface))"}} />}
            {type == ResourceType.TEXT && <div className="card standard-padding w-100" style={{maxHeight: "60vh", overflow: "auto"}}>
                <MarkdownFromUrl url={url} />
            </div>}
        </div>
    </>)
}